import type { ReactElement } from 'react';
import { Children, useMemo, isValidElement } from 'react';

/**
 * Хелпер для экстракта определенного пропа из чилдренов в виде массива
 * @example ```ts
 * const arrOfValues = getChildrenProp(children as ReactElement<{ value: string }>, 'value');
 * ```
 */
export function getChildrenProp<Props, Key extends keyof Props>(
    children: ReactElement<Props>,
    keyName: Key
): Array<Props[Key] | undefined> {
    const result: Array<Props[Key] | undefined> = [];
    Children.forEach(children, child => {
        if (isValidElement(child)) {
            result.push(child.props[keyName]);
        } else {
            result.push(undefined);
        }
    });

    return result;
}

export function useGetChildrenProp<Props, Key extends keyof Props>(
    children: ReactElement<Props>,
    keyName: Key
) {
    return useMemo(() => getChildrenProp(children, keyName), [children, keyName]);
}
